
document.addEventListener("DOMContentLoaded", function() {

	var $ = jQuery.noConflict(), i = 0, p = 0, l = 0;

	$('.swiper-slider--latest .post-loop ul').addClass('swiper-wrapper');
	$('.swiper-slider--latest .wp-block-post').addClass('swiper-slide');

	var swiper = new Swiper('.swiper-slider--latest .post-loop', {
		updateOnWindowResize: true,
		slidesPerColumnFill: 'row',
		slidesPerView: 3,
		spaceBetween: 50,
		loop: true,
		speed: 2000,
		autoplay: {
			delay: 4000,
			disableOnInteraction: false,
		},
		breakpoints: {
			320: {
				spaceBetween: 25,
				slidesPerView: 1.1
			},
			760: {
				slidesPerView: 1.5
			},
			992: {
				slidesPerView: 2
			},
			1281: {
				slidesPerView: 2.5
			}
		},
		keyboard: {
			enabled: true,
			onlyInViewport: false,
		},
		navigation: {
			nextEl: '.swiper_prod-next',
			prevEl: '.swiper_prod-prev',
		},
		pagination: false,
		grabCursor: true
	});

	var swiper = new Swiper('.testimonials-slider', {
		observeSlideChildren: true,
		slideToClickedSlide: true,
		updateOnWindowResize: true,
		slidesPerColumnFill: 'row',
		centeredSlides: false,
		autoHeight: true,
		slidesPerView: 1.5,
		spaceBetween: 0,
		loop: true,
		speed: 5000,
		// autoplay: {
		// 	delay: 7000,
		// 	disableOnInteraction: false,
		// },
		keyboard: {
			enabled: true,
			onlyInViewport: false,
		},
		pagination: {
			el: '.swiper-pagination',
			clickable: true,
		},
		navigation: {
			nextEl: '.swiper_testimonials-next',
			prevEl: '.swiper_testimonials-prev',
		},
		breakpoints: {
			320: {
				slidesPerView: 1
			},
			760: {
				slidesPerView: 1
			},
			992: {
				slidesPerView: 1
			},
			1281: {
				slidesPerView: 1.5
			}
		},
		grabCursor: true
	});

	$('.wp-block-query--machines__slider ul').addClass('swiper-wrapper');
	$('.wp-block-query--machines__slider ul li').addClass('swiper-slide');

	var swiper = new Swiper('.wp-block-query--machines__slider', {
		updateOnWindowResize: true,
		slidesPerColumnFill: 'row',
		slidesPerView: 4,
		spaceBetween: 40,
		loop: true,
		speed: 2000,
		autoplay: {
			delay: 4000,
			disableOnInteraction: false,
		},
		breakpoints: {
			320: {
				slidesPerView: 1.2
			},
			760: {
				slidesPerView: 2.2
			},
			992: {
				slidesPerView: 4
			},
			1281: {
				slidesPerView: 4
			}
		},
		keyboard: {
			enabled: true,
			onlyInViewport: false,
		},
		navigation: {
			nextEl: '.swiper__nav-mac--next',
			prevEl: '.swiper__nav-mac--prev',
		},
		pagination: false,
		grabCursor: true
	});
});